import { useNavigate } from "react-router-dom";
import Image from "../../designLayouts/Image";
import { selectFilters } from "../../../redux/filtersSlice";
import { useSelector } from "react-redux";
const ProductListView = (props) => {
  const navigate = useNavigate();

  const productItem = props;
  const _id = productItem?._id;
  const display_stock = Number(sessionStorage.getItem("display_stock"));

  const idString = (_id) => {
    return String(_id)?.toLowerCase()?.split(" ")?.join("");
  };
  const rootId = idString(_id);

  const { ratio: aspect_ratio = "1/1" } =
    useSelector(selectFilters)?.filters || {};

  const handleProductDetails = () => {
    navigate(`/product/${rootId}`);
  };
  const price = parseFloat(props?.price?.replace(/,/g, "")) || 0;
  const disc_price = parseFloat(props?.disc_price?.replace(/,/g, "")) || 0;

  return (
    <div>
      <div
        className="w-full flex items-start border-b border-gray-200 p-1 md:p-3 hover:bg-gray-50 duration-300"
        onClick={handleProductDetails}
      >
        {/* Product Image */}
        <div className="flex-shrink-0 w-[20%] min-w-[100px]  relative">
          <Image
            className="w-full  object-cover"
            imgSrc={props?.img}
            aspectRatio={aspect_ratio}
          />
        </div>

        {/* Product Details */}
        <div className="flex flex-col gap-1 justify-between flex-grow px-4 ">
          {/* Product Name */}
          <h2 className="text-sm md:text-md font-bold break-words">
            {props?.sku}
          </h2>

          {/* SKU */}
          <p className="text-xs md:text-sm break-words">{props?.productName}</p>

          {/* Stock Information */}
          <div className="flex justify-between w-[60%]">
            {display_stock === 1 ? (
              props?.stock > 0 ? (
                <p className="text-sm mt-auto">
                  {props?.stock} {props?.unit}
                </p>
              ) : (
                <p className="text-sm font-semibold text-red-600 mt-auto">
                  Out Of Stock
                </p>
              )
            ) : display_stock === 2 ? (
              <p className="text-sm font-semibold mt-auto">
                {props?.stock > 0 ? (
                  <span>Available</span>
                ) : (
                  <span className="text-red-500">Out Of Stock</span>
                )}
              </p>
            ) : (
              <p className="text-sm font-semibold mt-auto invisible">void</p>
            )}
            <div className="text-sm">
              {props?.disc_perc &&
              disc_price &&
              props?.disc_price !== props?.price ? (
                <div className="flex flex-row-reverse items-start gap-4">
                  <div>
                    {/* Original Price */}
                    <p className="">
                      <span className="font-semibold text-sm  decoration-red-500 text-red-500">
                        {props?.curr}{" "}
                      </span>
                      <span className="line-through decoration-red-500 text-red-500">
                        {price}
                      </span>
                    </p>
                    {/* Discount Price */}
                    <p className="font-medium ">
                      <span className="font-semiboldtext-sm">
                        {props?.curr} {props?.disc_price}
                      </span>
                    </p>
                  </div>
                  {/* Discount Percentage */}
                  <div className="bg-green-500 text-white aspect-square p-1 rounded-full flex items-center justify-center my-auto text-sm font-bold">
                    {Number(props?.disc_perc)?.toFixed(0)}%
                  </div>
                </div>
              ) : (
                // Display only the original price if no discount
                price >= 0 && (
                  <p>
                    <span className="font-semibold text-sm">
                      {props?.curr}{" "}
                    </span>
                    {props?.price}
                  </p>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductListView;
